/** First letter of a display name for avatar fallbacks. */
export function getNameInitial(name: string | null | undefined): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return "?";
  return trimmed[0].toUpperCase();
}

/** Avatar URL with ui-avatars single-letter fallback (map markers / img-only contexts). */
export function memberAvatarUrl(
  avatar: string | null | undefined,
  name: string,
  size = 256,
): string {
  if (avatar?.trim()) return avatar.trim();
  const initial = encodeURIComponent(getNameInitial(name) || "M");
  return `https://ui-avatars.com/api/?name=${initial}&background=ff3366&color=fff&size=${size}&length=1`;
}
